import { gql } from '@apollo/client';
import observationReportDocumentFragment from './observationReportDocumentFragment';

const UPDATE_OBSERVATION_REPORT_DOCUMENT = gql`
  mutation UpdateObservationReportDocument(
    $observationReportDocument: ObservationReportDocumentInput!
  ) {
    updateObservationReportDocument(observationReportDocument: $observationReportDocument) {
      ...ObservationReportFields
    }
  }
  ${observationReportDocumentFragment}
`;

export default UPDATE_OBSERVATION_REPORT_DOCUMENT;
